import React  from 'react';
import CurrencyComponentProto from './currency-proto.jsx';


export default function renderCurrencyInList(id, props) {
    return <CurrencyComponentProto renderMode="list" id={id} {...props} />;
}